<template>
  <div>
    <div class="mb-3">
      <h4 class="title">{{ $t('titles.action_required') }}</h4>
      <div class="mb-3">
        <div v-html="text" class="text mt-2 mb-2"></div>
        <PrimaryButton cta @click.prevent="doAction" :disabled="actionDisabled">
          {{ this.buttonLabel }}
        </PrimaryButton>
      </div>
      <StripeConfirmAction
          :card-payment-details="cardPaymentDetails"
          :handle-card-payment-trigger="handleCardPaymentTrigger"
          @on-stripe-ready="onStripeReady"
          @on-error="onHandleCardPaymentError"
          @on-handle-card-payment="onHandleCardPayment"
          @on-requires-payment-method="onRequiresPaymentMethod"
        />
      <div class="">
        <div class="mt-2 mb-0 membership">
          <span class="membership-title  text-muted">{{ membership.membershipType.name }}</span>
          <span class="membership-action">
          </span>
        </div>

        <div class="details text-muted">
          <div v-if="membership.status == 'trialing'">
            <span class="label">
              {{$t('labels.trial_since')}}
            </span>
            <p>{{formatDate(membership.currentPeriodStart)}}</p>
          </div>
          <div v-else>
            <span class="label">
              {{$t('labels.active_since')}}
            </span>
            <p>{{formatDate(membership.currentPeriodStart)}}</p>
          </div>

          <div v-if="!membership.canceled">
            <span class="label">
              {{$t('labels.next_payment_date')}}
            </span>
            <p>{{formatDate(membership.currentPeriodEnd)}}</p>
          </div>
          <div v-if="membership.validUntil">
            <span class="label">
              {{$t('labels.cancel_date')}}
            </span>
            <p>{{formatDate(membership.validUntil)}}</p>
          </div>
          <div>
            <payment-source v-bind="membership.stripePaymentSource" @edit-payment="editPayment" v-if="membership.stripePaymentSource"/>
          </div>
        </div>

      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import PaymentSource from "./PaymentSource";
import PrimaryButton from "../buttons/PrimaryButton";
import Modal from '@/components/modal/ModalRegular.vue';
import { handleError, resetError } from "../../store/utils";
import LoadingIndicator from "../global/LoadingIndicator.vue";
import StripeConfirmAction from "../input/StripeConfirmAction.vue";
import markdown from "markdown";
export default {
  data() {
    return {
      handleCardPaymentTrigger: 0,
      state: "stripe_loading", // stripe_loading -> ready -> in_progress -> success|failed
    }
  },
  computed: {
    text() {
      return markdown.markdown.toHTML(this.$t('messages.action_required'));
    },
    buttonLabel() {
      if (this.state=='stripe_loading') {
        return this.$t('buttons.loading');
      }
      if (this.state=='in_progress') {
        return this.$t('buttons.processing');
      }
      return this.$t('buttons.complete_payment');
    },
    cardPaymentDetails() {
      if (!this.membership) {
        return null;
      }
      return {
        clientSecret: this.membership.stripeLastClientSecret
      }
    },
    branch() {
      return process.env.FG_APP_BRANCH
    },

    currentUser() {
      return this.$store.getters.currentUser
    },

    membership() {
      return this.currentUser.membership
    },

    actionRequired() {
      return this.membership && this.membership.status == 'incomplete'
    },

    actionDisabled() {
      if (['stripe_loading', 'in_progress', 'success'].includes(this.state)) {
        return true;
      }
      return false;
    }

  },
  methods: {
    editPayment() {
      this.$router.push('/edit')
    },
    doAction() {
      this.handleCardPaymentTrigger++
      this.state = "in_progress"
      resetError(this.$store.commit)
      // this.$router.push('/edit')
    },
    onRequiresPaymentMethod() {
      this.state = "ready"
      this.$router.push('/edit')
    },
    onHandleCardPaymentError(error) {
      this.state = "failed"
      handleError(this.$store.commit, error)
    },
    onStripeReady() {
      this.state="ready"
    },
    onHandleCardPayment(result) {
      // console.log('onHandleCardPayment', result)
      this.$store.dispatch('completeMembership', { id: this.membership.id }).then((_response) => {
        this.state = "success"
        // this.sendConversion(response);
        this.$router.replace({ path: '/success' })
      }).catch((err) => {
        this.state = "failed"
        console.warn(err)
        handleError(this.$store.commit, "Smth went wrong. Please reload the page and try again")
      })
    },
  },
  mounted() {
    if (!this.actionRequired) {
      this.state = "success"
      if (this.membership) {
        this.$router.replace({ path: '/success' })
      } else {
        this.$router.push({ path: '/' })
      }
    }
    // if (this.state == 'ready') {
    //   this.doAction();
    // }
  },

  watch: {
    // state(newVal) {
    //   if (newVal == 'ready') {
    //     this.doAction();
    //   }
    // }
  },

  components: {
    PrimaryButton,
    StripeConfirmAction,
    PaymentSource,
  }

}
</script>

<style scoped lang="scss">
.membership-container {
  width: 100%;
  margin-top: 30px;
}

h1 {
  margin-bottom: 3rem;
}

.membership {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .membership-title {
    flex-grow: 1;
  }

  .membership-action {
    padding-left: 10px;
    margin-top: -16px;
    margin-bottom: -16px;

    span:not(:last-child) {
      margin-right: 10px;
    }
  }

}

.text {
  max-width: 600px;
}

.details {


  //border-top: 1px solid $gray-2;
  & > div {
    //border-bottom: 1px solid $gray-2;
    display: flex;
    padding: 1rem 0 0 0;


    .label {
      flex-basis: 25%;
      @media screen and (max-width: 750px) {
        flex-basis: 50%;
      }
      //font-family: $secondary-font-family;
      //font-weight: bold;
      //text-transform: uppercase;
      //font-size: 14px;
    }

    p {
      padding: 0;
      margin: 0;
      //font-size: 14px;
      //font-family: $secondary-font-family;
    }
  }
}


</style>


